export default {
  // TITLE
  TitleControl: '',
  ShowTitleControl: { checked: true },
  StyleTitleControl: {
    fontSize: 20,
    color: '#000000',
    fontFamily: 'arial',
    bold: false,
    italic: false,
    underline: false,
    align: 'center',
  },
  // Drilldown
  DrilldownStyle: 'auto',
  // GENERAL
  SortValuesControl: 'Alfabética A-Z',
  CustomSortControl: {
    checked: false, kpiCategories: [],
  },
  // SortDDControl: 'auto',
  InnerRadiusControl: { value: 0 },
  PaddingAngleControl: { value: 0 },
  CornerRadiusControl: { value: 0 },
  Margin: {
    top: 50,
    right: 110,
    bottom: 50,
    left: 60,
  },
  DataFormat: 'absolute', // { type: 'absolute', target: 'global' },
  DataPercentFormat: 'global',
  DataAbsoluteFormat: 'number',
  DataFormatAlt: 'none',
  DataPercentFormatAlt: 'global',
  DataAbsoluteFormatAlt: 'number',
  DurationUnit: 'hours',
  // STYLE
  BorderWidthControl: { value: 0 },
  BorderColorControl: { from: 'color', modifiers: [['darker', 1.6]] },
  PalletsControl: 'default',
  ColorTheme: { scheme: 'nivo' },
  GradientPickerControl: {
    color1: '#4711B2',
    color2: '#FF9626',
    color3: null,
  },
  Colors: {},
  // DDPalletsControl: 'auto',
  // DDColorTheme: { scheme: 'nivo' },
  // DDGradientPickerControl: {
  //   color1: '#4711B2',
  //   color2: '#FF9626',
  //   color3: null,
  // },
  UseGlobalColor: true,
  UseGlobalFont: true,
  // LABEL
  EnableLabelControl: { checked: true },
  SliceTextColorControl: { from: 'color', modifiers: [['darker', 1.6]] },
  EnableLabelMinControl: false,
  LabelMinPercentControl: 0,
  PrefixControl: '',
  SufixControl: '',
  RadialLabelControl: { checked: true },
  LabelTextColorControl: { from: 'color', modifiers: [['darker', 1.6]] },
  LabelsFontFamilyControl: { value: 'sans-serif' },
  LabelsFontSizeControl: { value: 15 },
  Decimals: 'auto',
  separadorNumericoCasas: '0',
  LabelCurrencyControl: 'Nenhum',
  LabelGroupingControl: '',
  // LEGEND
  LegendControl: { checked: true },
  LegendPlacementControl: {
    value: {
      label: 'Direita',
      translateX: 110,
      translateY: 0,
      selectedPosition: 'right',
      direction: 'column',
      anchor: 'right',
    },
  },
  LegendsFontFamilyControl: { value: 'sans-serif' },
  LegendsFontSizeControl: { value: 12 },
  LegendBold: false,
  LegendItalic: false,
  LegendFontColor: '#999',
  LegendsSpacingControl: { value: 10 },
  LegendSymbolControl: 'circle',
  // TOOLTIP / INTERACTIVE
  InteractiveControl: true,
  InteractivePrefixControl: '',
  InteractiveSufixControl: '',
  InteractiveDecimals: 'auto',
  InteractiveSeparadorNumericoCasas: 0,
  InteractiveCurrencyControl: 'Nenhum',
  InteractiveGroupingControl: '',
  Animate: false,
  MotionConfig: 'default',
  PartExtension: 0,
};
